import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Button, Modal, notification, Space } from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { useForm } from "antd/es/form/Form";
import { Warehouse } from "@/root/models/warehouse";
import ActionWarehouseModal from "./ActionWarehouseModal";
import useWarehouses from "@/hooks/useWarehouses";
import { CreateWarehousePayload } from "@/api/warehouses";

const { confirm } = Modal;

interface WarehousesTableActionsProps {
  warehouse: Warehouse;
  modal: string | null;
  onCancel: () => void;
  onModalOpen: () => void;
  onEditSuccess: () => void;
}

const WarehousesTableActions = ({
  warehouse,
  modal,
  onCancel,
  onEditSuccess,
  onModalOpen,
}: WarehousesTableActionsProps) => {
  const { t } = useTranslation();
  const [form] = useForm();

  const onDeleteError = (message: string) => {
    notification.error({
      message: message,
    });
  };

  const onSuccessEdit = () => {
    onEditSuccess();
    notification.success({
      message: t("Склад був успішно змінений"),
    });
  };

  const {
    editWarehouse,
    editError,
    editLoading,
    deleteLoading,
    deleteWarehouse,
  } = useWarehouses(onSuccessEdit, onDeleteError);

  const handleDeleteButtonClick = () => {
    confirm({
      title: t("Підтвердити видалення"),
      okText: t("Видалити"),
      okType: "danger",
      cancelText: t("Скасувати"),
      onOk: () => {
        deleteWarehouse(warehouse.warehouseUUID);
        notification.success({
          message: t("Склад був успішно видалений"),
        });
      },
    });
  };

  const handleEdit = (payload: CreateWarehousePayload) => {
    editWarehouse(warehouse.warehouseUUID, payload);
  };

  const onHandleOpen = () => {
    onModalOpen();
  };

  useEffect(() => {
    modal && form.setFieldsValue(warehouse);
  }, [modal]);

  return (
    <Space className="table-actions" size="middle">
      <Button size="small" icon={<EditOutlined />} onClick={onHandleOpen} />
      <Button
        size="small"
        icon={<DeleteOutlined />}
        loading={deleteLoading}
        danger
        onClick={handleDeleteButtonClick}
      />
      <ActionWarehouseModal
        modal={modal}
        onCancel={onCancel}
        type="edit"
        form={form}
        handleSubmit={handleEdit}
        error={editError}
        loading={editLoading}
        warehouseUUID={warehouse.warehouseUUID}
      />
    </Space>
  );
};

export default WarehousesTableActions;
